import React from "react";
import PropTypes from "prop-types";
import { Grid, Card, Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function EntityKeyMetrics({ metrics, hasActualImpressions, hasActualReach, reachLabel, impressionsLabel }) {
    const items = [
        {
            label: hasActualImpressions ? "Views" : "Est. Views",
            value: metrics["Views"] || metrics[impressionsLabel],
            color: "info",
            icon: <Icon>visibility</Icon>
        },
        {
            label: hasActualReach ? "Reach" : "Est. Reach",
            value: metrics[reachLabel],
            color: "dark",
            icon: <Icon>public</Icon>
        },
        {
            label: "Engagement",
            value: metrics["Engagement"],
            color: "success",
            icon: <Icon>trending_up</Icon>
        }
    ];

    return (
        <Grid container spacing={2} mb={3}>
            {items.map((item, idx) => (
                <Grid item xs={4} key={idx}>
                    <Card
                        sx={{
                            p: 2,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: "center",
                            height: "100%",
                            boxShadow: 3,
                            borderRadius: 2,
                            background: "linear-gradient(145deg, #ffffff, #f0f2f5)"
                        }}
                    >
                        <MDBox color={item.color} mb={1} lineHeight={0}>
                            {item.icon}
                        </MDBox>
                        <MDTypography variant="h5" fontWeight="bold" color={item.color}>
                            {typeof item.value === 'number' ? item.value.toLocaleString() : (item.value || 0)}
                        </MDTypography>
                        <MDTypography variant="caption" color="text" textTransform="uppercase" fontWeight="bold" sx={{ fontSize: "0.7rem", mt: 0.5 }}>
                            {item.label}
                        </MDTypography>
                    </Card>
                </Grid>
            ))}
        </Grid>
    );
}

EntityKeyMetrics.propTypes = {
    metrics: PropTypes.object.isRequired,
    hasActualImpressions: PropTypes.bool,
    hasActualReach: PropTypes.bool,
    reachLabel: PropTypes.string,
    impressionsLabel: PropTypes.string,
};

export default EntityKeyMetrics;
